<script lang="ts">

    import Image from "./Image.svelte";
    import { assets as assetPath} from "$app/paths";

    //TODO update url to image
    export let webpUrl : string = "";
    export let pngUrl : string;
    export let imageAlt : string;
    export let heading : string;
    export let description: string;

</script>

<div class="stepCard">
    <Image pngUrl={assetPath + pngUrl} webpUrl={assetPath + webpUrl} alt={imageAlt} loading="lazy" />
    <div class="stepCard__info">
        <h3>{heading}</h3>
        <p>{description}</p>
    </div>
</div>

<style lang="postcss">
    @import '../../styles/_mixins.css';
    .stepCard {
        display: flex;
        flex-direction: column;
        width:45%;

        @mixin screen-sm {
            width:100%;
        }

        & .stepCard__info {

            padding:0px;
            margin-bottom:60px;
            height:200px;
            max-width:300px;

            @mixin screen-lg {
                height:220px;
            }

            @mixin screen-md {
                height: 180px;
            }

            @mixin screen-sm {
                height:inherit;
                max-width:100%;
                padding:24px 0 0;
                margin-bottom:60px;
            }

            & h3 {
                @mixin heading-h3;
                margin:24px 0 8px;
                color:var(--color_white);

                @mixin screen-sm {
                    margin:0 0 8px;
                }
            }

            & p {
                @mixin paragraph;
                margin:0;
                color:var(--color_offerzen_lightblue_secondary);
                font-size:16px;

                @mixin screen-sm {
                    font-size:18px;
                }
            }
        }

        & :global(img) {
            display: block;
            width:100%;
            aspect-ratio: 5/2.5;
            @mixin screen-md {
                width:90%;
            }
        }
    }
</style>